import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndo, faFilter, faList, faSpinner, faCheckSquare, faTimes, faDollarSign, faEye, faFileExcel, faUpload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';

class Mantenimiento extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            cargando: false,
            servicios: [],
            estadosList: [],
            clientesList: [],
            filtros: {
                fecha_inicio: '2026-08-01',
                fecha_fin: '2026-10-28',
                estado: '',
                facturado: '',
                numero_expediente: '',
                orden_servicio_new: '',
                numero_validador: '',
                nombre_cliente: '',
                cliente_id: '',
                tarifa: '',
                tarifa_cero: false
            },
            selectedIds: [],
            showTarifaModal: false,
            cargandoTarifas: false,
            tarifasCliente: [],
            filtroModalTarifa: '',
            tarifaSeleccionada: null,

            // Estados para Modal de Caracol
            showCaracolModal: false,
            cargandoCaracol: false,
            datosCaracol: [],
            servicioAsociadoConsultado: '',

            // Estados para Modal de Bit?cora
            showBitacoraModal: false,
            cargandoBitacora: false,
            datosBitacora: [],
            servicioIdBitacora: '',

            // Estados de Prefactura y Conductor Masivo
            idsFactura: [],
            idsConductor: [],
            idsProduccion: [],
            showConductoresModal: false,
            cargandoConductores: false,
            conductoresList: [],
            conductorSeleccionado: '',
            subtotalFactura: 0,
            Usuario: localStorage.getItem('Name') || 'Usuario',

            paginaActual: 1,
            registrosPorPagina: 50,
            tableScrollWidth: 3000
        };
        this.topScrollRef = React.createRef();
        this.tableContainerRef = React.createRef();
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        console.log("Componente Mantenimiento montado correctamente.");
        this.cargarListadoServicios();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.tableContainerRef.current) {
            const table = this.tableContainerRef.current.querySelector('table');
            if (table && table.offsetWidth !== this.state.tableScrollWidth && table.offsetWidth > 0) {
                this.setState({ tableScrollWidth: table.offsetWidth });
            }
        }
    }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState(prevState => ({
            filtros: {
                ...prevState.filtros,
                [name]: type === 'checkbox' ? checked : value
            }
        }));
    };

    cargarListadoServicios = () => {
        this.setState({ cargando: true, selectedIds: [] });
        Swal.showLoading();

        const { filtros } = this.state;
        const payload = {
            fecha_inicio: filtros.fecha_inicio,
            fecha_fin: filtros.fecha_fin,
            estado: filtros.estado,
            facturado: filtros.facturado,
            numero_expediente: filtros.numero_expediente,
            orden_servicio_new: filtros.orden_servicio_new,
            numero_validador: filtros.numero_validador,
            nombre_cliente: filtros.nombre_cliente,
            cliente_id: filtros.cliente_id,
            tarifa: filtros.tarifa,
            tarifa_cero: filtros.tarifa_cero ? '1' : '0'
        };

        authAxios.post("exterior/listado-servicios", payload)
            .then((res) => {
                Swal.close();
                if (res.data && res.data.data) {
                    this.setState({
                        servicios: res.data.data,
                        estadosList: res.data.estados || [],
                        clientesList: res.data.clientes || [],
                        datosCargados: true,
                        cargando: false,
                        paginaActual: 1
                    });
                } else {
                    this.setState({ servicios: [], cargando: false });
                }
            })
            .catch((err) => {
                authAxios.post("listado-servicios", payload)
                    .then((res) => {
                        Swal.close();
                        if (res.data && res.data.data) {
                            this.setState({
                                servicios: res.data.data,
                                estadosList: res.data.estados || [],
                                clientesList: res.data.clientes || [],
                                datosCargados: true,
                                cargando: false,
                                paginaActual: 1
                            });
                        } else {
                            this.setState({ servicios: [], cargando: false });
                        }
                    })
                    .catch((err2) => {
                        Swal.close();
                        console.error("Error cargando listado de servicios:", err2);
                        this.setState({ cargando: false });
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de Conexi?n',
                            text: 'No se pudo consultar la API de servicios'
                        });
                    });
            });
    };

    limpiarFiltros = () => {
        this.setState({
            filtros: {
                fecha_inicio: '2026-08-01',
                fecha_fin: '2026-10-28',
                estado: '',
                facturado: '',
                numero_expediente: '',
                orden_servicio_new: '',
                numero_validador: '',
                nombre_cliente: '',
                cliente_id: '',
                tarifa: '',
                tarifa_cero: false
            },
            selectedIds: []
        }, () => {
            this.cargarListadoServicios();
        });
    };

    exportarExcel = () => {
        const { servicios } = this.state;
        if (!servicios || servicios.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenci?n',
                text: 'No hay servicios cargados en la lista para exportar.'
            });
            return;
        }

        // Encabezados del Excel
        const headers = [
            "ID",
            "Fecha",
            "Cliente / Origen",
            "Producci?n",
            "Veh?culo Sugerido",
            "Conductor",
            "Estado Servicio",
            "Factura",
            "No. Expediente",
            "Posici?n",
            "Nombre Tarifa",
            "Valor Tarifa",
            "Valor Api",
            "Valor Servicio",
            "Diferencia",
            "Pago a Conductor",
            "Modalidad",
            "Cantidad",
            "Servicio Asociado",
            "Orden Servicio (New)",
            "No. Validador"
        ];

        // Filas de datos
        const rows = servicios.map(item => {
            const valTarifa = Number(item.valor_tarifa || item.valor_sin_iva || 0);
            const valServicio = Number(item.valor_servicio || 0);
            const dif = valServicio - valTarifa;
            const numFactura = item.factura_prefactura || 'Sin Factura';

            return [
                item.id,
                item.fecha || '',
                `"${(item.nombre_cliente || '').replace(/"/g, '""')}"`,
                `"${(item.nombre_produccion || '').replace(/"/g, '""')}"`,
                `"${(item.vehiculo_sugerido || '').replace(/"/g, '""')}"`,
                `"${(item.nombre_conductor || item.conductor || '').replace(/"/g, '""')}"`,
                `"${(item.estado || '').replace(/"/g, '""')}"`,
                `"${numFactura}"`,
                `"${(item.numero_expediente || '').replace(/"/g, '""')}"`,
                item.posicion || 0,
                `"${(item.nombre_tarifa || '').replace(/"/g, '""')}"`,
                valTarifa,
                 `"${(item.valor_api || item.valor_api || '').replace(/"/g, '""')}"`,
                valServicio,
                dif,
                Number(item.pago_conductor || item.costo_tercero || 0),
                `"${(item.modalidad || '').replace(/"/g, '""')}"`,
                item.cantidad || 0,
                `"${(item.servicioAsociado || '').replace(/"/g, '""')}"`,
                `"${(item.orden_servicio_new || '').replace(/"/g, '""')}"`,
                `"${(item.numero_validador || '').replace(/"/g, '""')}"`
            ];
        });

        const csvContent = "\uFEFF" + [headers.join(";"), ...rows.map(e => e.join(";"))].join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `Listado_Servicios_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Swal.fire({
            icon: 'success',
            title: '?Exportado!',
            text: `Se han exportado ${servicios.length} registros a Excel (CSV).`,
            timer: 2000,
            showConfirmButton: false
        });
    };

    handleExcelUpload = (e) => {
        const file = e.target.files[0];
        if(!file) return;

        Swal.fire({
            title: 'Procesando Excel',
            text: 'Leyendo archivo...',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws, { defval: "" });

                if(data.length === 0) {
                    Swal.fire('Error', 'El Excel est? vac?o', 'error');
                    return;
                }

                // Buscar columnas clave
                const keys = Object.keys(data[0]);
                const colDoc = keys.find(k => k.toLowerCase().includes('documento'));
                const colPos = keys.find(k => k.toLowerCase().includes('posici'));
                const colValor = keys.find(k => k.toLowerCase().includes('neto'));
                const colUnidad = keys.find(k => k.toLowerCase().includes('unidad'));
                const colCantPedido = keys.find(k => k.toLowerCase().includes('cantidad de pedido'));
                const colCantEntrada = keys.find(k => k.toLowerCase().includes('cantidad entrada'));

                if(!colDoc || !colPos || !colValor) {
                    Swal.fire('Error', 'No se encontraron las columnas necesarias (Documento, Posici?n, VALOR A FACTURAR)', 'error');
                    return;
                }

                const procesados = data.map(row => ({
                    orden_servicio_new: row[colDoc],
                    posicion: row[colPos],
                    valor: row[colValor],
                    unidad: row[colUnidad],
                    cant_pedido: colCantPedido ? row[colCantPedido] : null,
                    cant_entrada: colCantEntrada ? row[colCantEntrada] : null
                })).filter(r => r.orden_servicio_new && r.posicion);

                if(procesados.length === 0) {
                    Swal.fire('Error', 'No se encontraron filas con Documento y Posicion', 'error');
                    return;
                }

                const resultOpcion = await Swal.fire({
                    title: 'Que campo desea actualizar?',
                    text: "Seleccione el valor que se actualizara con los datos del Excel",
                    icon: 'question',
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Valor API',
                    denyButtonText: 'Valor Servicio',
                    cancelButtonText: 'Cancelar'
                });

                if (resultOpcion.isDismissed) {
                    return;
                }

                const campoActualizar = resultOpcion.isConfirmed ? 'valor_api' : 'valor_servicio';

                Swal.fire({
                    title: 'Actualizando',
                    text: 'Cargando y actualizando datos...',
                    allowOutsideClick: false,
                    didOpen: () => { Swal.showLoading(); }
                });

                const usuarioId = localStorage.getItem('idusuario') || localStorage.getItem('usuario_id') || localStorage.getItem('id_usuario') || '';
                const response = await authAxios.post('exterior/actualizar-desde-excel', { 
                    datos: procesados,
                    campo_actualizar: campoActualizar,
                    usuario: usuarioId
                });
                
                if(response.data && response.data.success) {
                    const currentServicios = this.state.servicios;
                    const nuevosServicios = currentServicios.filter(s => {
                        const encontrado = procesados.find(p => String(p.orden_servicio_new) === String(s.orden_servicio_new) && String(p.posicion) === String(s.posicion));
                        if(encontrado) {
                            s[campoActualizar] = encontrado.valor;
                            return true;
                        }
                        return false;
                    });

                    this.setState((prevState) => {
                        let nuevosFiltros = { ...prevState.filtros };
                        if (response.data.expedientes && response.data.expedientes.length > 0) {
                            nuevosFiltros.numero_expediente = response.data.expedientes.join(',');
                        }

                        return {
                            servicios: nuevosServicios,
                            paginaActual: 1,
                            filtros: nuevosFiltros
                        };
                    }, () => {
                        if (response.data.expedientes && response.data.expedientes.length > 0) {
                            this.cargarListadoServicios();
                        }
                    });

                    Swal.fire('?xito', response.data.message, 'success');
                } else {
                    Swal.fire('Error', response.data?.message || 'Error al actualizar', 'error');
                }

            } catch (error) {
                console.error(error);
                Swal.fire('Error', 'Error al procesar el archivo o actualizar los datos', 'error');
            }
            if(this.fileInputRef.current) this.fileInputRef.current.value = null;
        };
        reader.readAsBinaryString(file);
    };

    toggleSelectRow = (id) => {
        this.setState(prevState => {
            const exists = prevState.selectedIds.includes(id);
            if (exists) {
                return { selectedIds: prevState.selectedIds.filter(item => item !== id) };
            } else {
                return { selectedIds: [...prevState.selectedIds, id] };
            }
        });
    };

    toggleSelectAllCurrentPage = () => {
        const { servicios, paginaActual, registrosPorPagina, selectedIds } = this.state;
        const indiceInicial = (paginaActual - 1) * registrosPorPagina;
        const serviciosPaginados = servicios.slice(indiceInicial, indiceInicial + registrosPorPagina);
        const currentPageIds = serviciosPaginados.map(s => s.id);

        const allSelected = currentPageIds.every(id => selectedIds.includes(id));

        if (allSelected) {
            this.setState({
                selectedIds: selectedIds.filter(id => !currentPageIds.includes(id))
            });
        } else {
            const newSelected = Array.from(new Set([...selectedIds, ...currentPageIds]));
            this.setState({ selectedIds: newSelected });
        }
    };

    // Funciones de Prefactura
    UpValores = (id) => {
        let el = document.getElementById('valor' + id);
        if(!el) return;
        let valor = el.value;
        var datos = { id: id, valor: valor };
        authAxios.post("exterior/actualizavalor-servicio", datos)
            .then((datosRespuesta) => {
                this.setState((prevState) => {
                    const updatedServicios = prevState.servicios.map(item => {
                        if (item.id === id) {
                            return { ...item, valor_servicio: valor };
                        }
                        return item;
                    });
                    return { servicios: updatedServicios };
                }, this.calcularSubtotalFactura);
            })
            .catch(err => console.log(err));
    };

    UpCostoTercero = (id) => {
        let el = document.getElementById('costo_tercero' + id);
        if(!el) return;
        let valor = el.value;
        var datos = { id: id, valor: valor };
        authAxios.post("exterior/actualizacosto-tercero", datos)
            .then((datosRespuesta) => {
                this.setState((prevState) => {
                    const updatedServicios = prevState.servicios.map(item => {
                        if (item.id === id) {
                            return { ...item, costo_tercero: valor };
                        }
                        return item;
                    });
                    return { servicios: updatedServicios };
                });
            })
            .catch(err => console.log(err));
    };

    UpProduccion = (id) => {
        let el = document.getElementById('produccion' + id);
        if(!el) return;
        let valor = el.value;
        var datos = { id: id, valor: valor };
        authAxios.post("exterior/actualizavalor-servicio-produccion", datos)
            .then((datosRespuesta) => {
                this.setState((prevState) => {
                    const updatedServicios = prevState.servicios.map(item => {
                        if (item.id === id) {
                            return { ...item, produccion: valor };
                        }
                        return item;
                    });
                    return { servicios: updatedServicios };
                });
            })
            .catch(err => console.log(err));
    };

    calcularSubtotalFactura = () => {
        const { servicios, idsFactura } = this.state;
        const subtotal = servicios.reduce((total, item) => {
            return idsFactura.includes(item.id) ? total + parseFloat(item.valor_servicio || 0) : total;
        }, 0);
        this.setState({ subtotalFactura: subtotal });
    };

    handleCheckboxFacturaChange = (id) => {
        this.setState((prevState) => {
            const { idsFactura } = prevState;
            const updatedIds = idsFactura.includes(id) ? idsFactura.filter(itemId => itemId !== id) : [...idsFactura, id];
            return { idsFactura: updatedIds };
        }, this.calcularSubtotalFactura);
    };

    toggleSelectAllFacturaCurrentPage = () => {
        const { servicios, paginaActual, registrosPorPagina, idsFactura } = this.state;
        const indiceInicial = (paginaActual - 1) * registrosPorPagina;
        const serviciosPaginados = servicios.slice(indiceInicial, indiceInicial + registrosPorPagina);
        
        const currentPageValids = serviciosPaginados.filter(s => {
            const valServicio = Number(s.valor_servicio || 0);
            const numFactura = s.factura_prefactura;
            return valServicio > 0 && (!numFactura || numFactura === '0');
        }).map(s => s.id);

        const allSelected = currentPageValids.every(id => idsFactura.includes(id));

        if (allSelected && currentPageValids.length > 0) {
            this.setState({
                idsFactura: idsFactura.filter(id => !currentPageValids.includes(id))
            }, this.calcularSubtotalFactura);
        } else {
            const newSelected = Array.from(new Set([...idsFactura, ...currentPageValids]));
            this.setState({ idsFactura: newSelected }, this.calcularSubtotalFactura);
        }
    };

    GuardarValores = () => {
        Swal.fire({
            title: '?Est? seguro de Generar la prefactura?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Generar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                const { idsFactura, Usuario } = this.state;
                if (idsFactura.length === 0) {
                    Swal.fire('Atenci?n', 'Debes de seleccionar los servicios', 'warning');
                    return false;
                }

                var datos = { id: idsFactura, usuario: Usuario, origen: '' };
                authAxios.post("exterior/guardarseleccionado-servicios", datos)
                    .then((datosRespuesta) => {
                        Swal.close();
                        var m = datosRespuesta.data.msj;
                        this.setState({ idsFactura: [] });
                        Swal.fire({
                            title: m,
                            text: 'Facturado',
                            icon: 'success',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((res2) => {
                            if (res2.isConfirmed) {
                                this.cargarListadoServicios();
                            }
                        });
                    })
                    .catch(err => {
                        Swal.fire('Error', 'Ocurri? un problema', 'error');
                    });
            }
        });
    };

    // Funciones de Conductor Masivo
    handleCheckboxConductorChange = (id) => {
        this.setState((prevState) => {
            const { idsConductor } = prevState;
            const updatedIds = idsConductor.includes(id) ? idsConductor.filter(itemId => itemId !== id) : [...idsConductor, id];
            return { idsConductor: updatedIds };
        });
    };

    handleCheckboxProduccionChange = (id) => {
        this.setState((prevState) => {
            const { idsProduccion } = prevState;
            const updatedIds = idsProduccion.includes(id) ? idsProduccion.filter(itemId => itemId !== id) : [...idsProduccion, id];
            return { idsProduccion: updatedIds };
        });
    };

    toggleSelectAllProduccionCurrentPage = () => {
        const { servicios, paginaActual, registrosPorPagina, idsProduccion } = this.state;
        const indiceInicial = (paginaActual - 1) * registrosPorPagina;
        const serviciosPaginados = servicios.slice(indiceInicial, indiceInicial + registrosPorPagina);
        
        const currentPageIds = serviciosPaginados.map(s => s.id);
        const allSelected = currentPageIds.length > 0 && currentPageIds.every(id => idsProduccion.includes(id));
        
        this.setState((prevState) => {
            let newIds = [...prevState.idsProduccion];
            if (allSelected) {
                newIds = newIds.filter(id => !currentPageIds.includes(id));
            } else {
                currentPageIds.forEach(id => {
                    if (!newIds.includes(id)) newIds.push(id);
                });
            }
            return { idsProduccion: newIds };
        });
    };

    abrirModalConductores = () => {
        const { idsConductor } = this.state;
        if (idsConductor.length === 0) {
            Swal.fire('Atenci?n', 'Debe seleccionar al menos un servicio para asignar conductor', 'warning');
            return;
        }
        this.setState({ showConductoresModal: true, cargandoConductores: true, conductoresList: [] });
        
        authAxios.get("exterior/obtener-conductores-activos")
            .then(res => {
                if (res.data && res.data.datos) {
                    this.setState({ conductoresList: res.data.datos, cargandoConductores: false });
                } else {
                    this.setState({ cargandoConductores: false });
                }
            })
            .catch(() => this.setState({ cargandoConductores: false }));
    };

    cerrarModalConductores = () => {
        this.setState({ showConductoresModal: false, conductorSeleccionado: '' });
    };

    asignarProduccionMasiva = async () => {
        const { idsProduccion } = this.state;
        if (idsProduccion.length === 0) {
            Swal.fire('Atención', 'Debe seleccionar al menos un servicio para asignar la producción', 'warning');
            return;
        }

        const { value: produccion } = await Swal.fire({
            title: 'Asignar Producción Masiva',
            input: 'text',
            inputLabel: 'Ingrese el nombre de la producción a asignar',
            inputPlaceholder: 'Ej: Producción XYZ',
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        });

        if (produccion !== undefined) { // Permite vacío o texto
            this.guardarProduccionMasiva(produccion);
        }
    };

    guardarProduccionMasiva = (produccion) => {
        const { idsProduccion } = this.state;
        Swal.showLoading();
        const payload = {
            id: idsProduccion,
            valor: produccion
        };

        authAxios.post("exterior/actualizavalor-servicio-produccion", payload)
            .then(res => {
                Swal.close();
                if (res.data.status === 1 || res.data.msj) {
                    Swal.fire('¡Actualizado!', res.data.msj || 'Se actualizaron las producciones con éxito', 'success');
                    this.setState({ idsProduccion: [] });
                    this.cargarListadoServicios();
                } else {
                    Swal.fire('Atención', 'Ocurrió un error en la actualización', 'warning');
                }
            })
            .catch(err => {
                Swal.close();
                Swal.fire('Error', 'Ocurrió un problema en la petición', 'error');
            });
    };

    guardarConductorMasivo = () => {
        const { idsConductor, conductorSeleccionado } = this.state;
        if (!conductorSeleccionado) {
            Swal.fire('Atenci?n', 'Debe seleccionar un conductor', 'warning');
            return;
        }

        Swal.showLoading();
        const payload = {
            id: idsConductor,
            conductor_id: conductorSeleccionado
        };

        authAxios.post("exterior/asignar-conductor-masivo", payload)
            .then(res => {
                Swal.close();
                if (res.data && res.data.status === 'success') {
                    Swal.fire('?Actualizado!', res.data.msj, 'success');
                    this.cerrarModalConductores();
                    this.setState({ idsConductor: [] });
                    this.cargarListadoServicios();
                } else {
                    Swal.fire('Error', res.data.msj || 'No se pudo asignar', 'error');
                }
            })
            .catch(err => Swal.fire('Error', 'Ocurri? un problema', 'error'));
    };

    abrirModalTarifas = () => {
        const { selectedIds, servicios, filtros } = this.state;
        if (selectedIds.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenci?n',
                text: 'Debe seleccionar al menos un servicio para asignar tarifa'
            });
            return;
        }

        const primerServicio = servicios.find(s => s.id === selectedIds[0]);
        const clienteIdFinal = filtros.cliente_id || (primerServicio ? primerServicio.origen : null);

        if (!clienteIdFinal) {
            Swal.fire({
                icon: 'warning',
                title: 'Cliente no identificado',
                text: 'Por favor seleccione un cliente en los filtros para cargar sus tarifas'
            });
            return;
        }

        this.setState({ showTarifaModal: true, cargandoTarifas: true, tarifasCliente: [], filtroModalTarifa: '' });
        Swal.showLoading();

        authAxios.post("exterior/obtener-tarifas-cliente", { cliente_id: clienteIdFinal })
            .then(res => {
                Swal.close();
                if (res.data && res.data.tarifas) {
                    this.setState({ tarifasCliente: res.data.tarifas, cargandoTarifas: false });
                } else {
                    this.setState({ tarifasCliente: [], cargandoTarifas: false });
                }
            })
            .catch(() => {
                authAxios.post("obtener-tarifas-cliente", { cliente_id: clienteIdFinal })
                    .then(res => {
                        Swal.close();
                        if (res.data && res.data.tarifas) {
                            this.setState({ tarifasCliente: res.data.tarifas, cargandoTarifas: false });
                        } else {
                            this.setState({ tarifasCliente: [], cargandoTarifas: false });
                        }
                    })
                    .catch(err => {
                        Swal.close();
                        this.setState({ cargandoTarifas: false });
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'No se pudieron consultar las tarifas del cliente'
                        });
                    });
            });
    };

    cerrarModalTarifas = () => {
        this.setState({ showTarifaModal: false, tarifaSeleccionada: null, filtroModalTarifa: '' });
    };

    seleccionarYActualizarTarifa = (tarifaItem) => {
        const { selectedIds } = this.state;
        Swal.fire({
            title: '?Confirmar actualizaci?n?',
            text: `Se asignar? la Tarifa #${tarifaItem.id} (${tarifaItem.modalidad || 'Sin modalidad'}) a los ${selectedIds.length} servicios seleccionados.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'S?, actualizar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                const payload = {
                    ids: selectedIds,
                    tarifa_id: tarifaItem.id
                };

                authAxios.post("exterior/editar-servicio-seleccionado", payload)
                    .then(res => {
                        Swal.close();
                        if (res.data && res.data.status === 'success') {
                            Swal.fire({
                                icon: 'success',
                                title: '?Actualizado!',
                                text: res.data.msj || 'Tarifas actualizadas correctamente'
                            });
                            this.cerrarModalTarifas();
                            this.cargarListadoServicios();
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: res.data?.msj || 'No se pudo actualizar la tarifa'
                            });
                        }
                    })
                    .catch(err => {
                        authAxios.post("editar-servicio-seleccionado", payload)
                            .then(res => {
                                Swal.close();
                                if (res.data && res.data.status === 'success') {
                                    Swal.fire({
                                        icon: 'success',
                                        title: '?Actualizado!',
                                        text: res.data.msj || 'Tarifas actualizadas correctamente'
                                    });
                                    this.cerrarModalTarifas();
                                    this.cargarListadoServicios();
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Error',
                                        text: res.data?.msj || 'No se pudo actualizar la tarifa'
                                    });
                                }
                            })
                            .catch(err2 => {
                                Swal.close();
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Ocurri? un problema al enviar la actualizaci?n: ' + (err2.response?.data?.msj || err2.message)
                                });
                            });
                    });
            }
        });
    };

    // Consulta de Servicio desde Caracol API
    consultarServicioCaracol = (servicioAsociado, fechaServicio) => {
        if (!servicioAsociado || servicioAsociado === '0') {
            Swal.fire({
                icon: 'warning',
                title: 'Atenci?n',
                text: 'No hay un n?mero de servicio asociado para consultar'
            });
            return;
        }

        const { filtros } = this.state;
        const fechaFin = filtros.fecha_fin || fechaServicio || '0';
        const fechaInicio = filtros.fecha_inicio || fechaServicio || '0';

        this.setState({
            showCaracolModal: true,
            cargandoCaracol: true,
            datosCaracol: [],
            servicioAsociadoConsultado: servicioAsociado
        });
        Swal.showLoading();

        const url = `transporte/consultarservicios/${servicioAsociado}/${fechaFin}/${fechaInicio}`;
        console.log("Consultando API Caracol URL:", url);

        authAxios.get(url)
            .then(res => {
                Swal.close();
                let list = [];
                if (res.data && Array.isArray(res.data) && res.data.length > 0 && res.data[0].datos) {
                    list = res.data[0].datos;
                } else if (res.data && Array.isArray(res.data)) {
                    list = res.data;
                }
                this.setState({ datosCaracol: list, cargandoCaracol: false });
            })
            .catch(err => {
                Swal.close();
                console.error("Error consultando API Caracol:", err);
                this.setState({ cargandoCaracol: false });
                Swal.fire({
                    icon: 'error',
                    title: 'Error de Conexi?n',
                    text: 'No se pudieron consultar los datos del servicio desde Caracol TV'
                });
            });
    };

    cerrarCaracolModal = () => {
        this.setState({ showCaracolModal: false, datosCaracol: [], servicioAsociadoConsultado: '' });
    };

    // Consulta de Bit?cora / Historial de Cambios del Servicio
    consultarBitacora = (servicioId) => {
        this.setState({
            showBitacoraModal: true,
            cargandoBitacora: true,
            datosBitacora: [],
            servicioIdBitacora: servicioId
        });
        Swal.showLoading();

        authAxios.post("exterior/bitacora-servicio", { id: servicioId })
            .then(res => {
                Swal.close();
                if (res.data && res.data.bitacora) {
                    this.setState({ datosBitacora: res.data.bitacora, cargandoBitacora: false });
                } else {
                    this.setState({ datosBitacora: [], cargandoBitacora: false });
                }
            })
            .catch(() => {
                authAxios.post("bitacora-servicio", { id: servicioId })
                    .then(res => {
                        Swal.close();
                        if (res.data && res.data.bitacora) {
                            this.setState({ datosBitacora: res.data.bitacora, cargandoBitacora: false });
                        } else {
                            this.setState({ datosBitacora: [], cargandoBitacora: false });
                        }
                    })
                    .catch(err => {
                        Swal.close();
                        this.setState({ cargandoBitacora: false });
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'No se pudo consultar la bit?cora del servicio'
                        });
                    });
            });
    };

    cerrarBitacoraModal = () => {
        this.setState({ showBitacoraModal: false, datosBitacora: [], servicioIdBitacora: '' });
    };

    cambiarPagina = (nuevaPagina) => {
        this.setState({ paginaActual: nuevaPagina });
    };

    render() {
        const {
            servicios, estadosList, clientesList, filtros, cargando, paginaActual, registrosPorPagina,
            selectedIds, showTarifaModal, cargandoTarifas, tarifasCliente, filtroModalTarifa,
            showCaracolModal, cargandoCaracol, datosCaracol, servicioAsociadoConsultado,
            showBitacoraModal, cargandoBitacora, datosBitacora, servicioIdBitacora
        } = this.state;

        // Paginaci?n en cliente
        const totalRegistros = servicios.length;
        const totalPaginas = Math.ceil(totalRegistros / registrosPorPagina) || 1;
        const indiceInicial = (paginaActual - 1) * registrosPorPagina;
        const serviciosPaginados = servicios.slice(indiceInicial, indiceInicial + registrosPorPagina);

        const currentPageIds = serviciosPaginados.map(s => s.id);
        const isAllSelectedCurrentPage = currentPageIds.length > 0 && currentPageIds.every(id => selectedIds.includes(id));

        // Filtrado din?mico dentro del modal de tarifa
        const tarifasFiltradas = tarifasCliente.filter(t => {
            if (!filtroModalTarifa) return true;
            const term = filtroModalTarifa.toLowerCase();
            return (
                String(t.id).toLowerCase().includes(term) ||
                String(t.vehiculo || '').toLowerCase().includes(term) ||
                String(t.produccion || '').toLowerCase().includes(term) ||
                String(t.modalidad || '').toLowerCase().includes(term) ||
                String(t.valor_sin_iva || '').toLowerCase().includes(term)
            );
        });

        return (
            <div className="content p-3">
                <div className="container-fluid">
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-primary text-white d-flex align-items-center justify-content-between">
                            <h4 className="mb-0 fs-5">
                                <FontAwesomeIcon icon={faList} className="me-2" />
                                Listado de Servicios & Mantenimiento
                            </h4>
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm font-weight-bold"
                                    onClick={this.exportarExcel}
                                    disabled={cargando || servicios.length === 0}
                                    title="Descargar listado en Excel"
                                >
                                    <FontAwesomeIcon icon={faFileExcel} className="me-1" />
                                    Descargar Excel
                                </button>
                                <span className="badge bg-light text-primary">
                                    Total: {totalRegistros} servicios
                                </span>
                            </div>
                        </div>

                        <div className="card-body">
                            {/* Panel de Filtros */}
                            <div className="card bg-light border-0 mb-4">
                                <div className="card-body">
                                    <h6 className="text-secondary mb-3">
                                        <FontAwesomeIcon icon={faFilter} className="me-2" />
                                        Filtros de B?squeda
                                    </h6>
                                    <div className="row g-3">
                                        {/* Rango de Fechas */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">Fecha Inicio</label>
                                            <input
                                                type="date"
                                                name="fecha_inicio"
                                                value={filtros.fecha_inicio}
                                                onChange={this.handleInputChange}
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">Fecha Fin</label>
                                            <input
                                                type="date"
                                                name="fecha_fin"
                                                value={filtros.fecha_fin}
                                                onChange={this.handleInputChange}
                                                className="form-control form-control-sm"
                                            />
                                        </div>

                                        {/* Cliente Activo */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">Cliente Activo</label>
                                            <select
                                                name="cliente_id"
                                                value={filtros.cliente_id}
                                                onChange={this.handleInputChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">-- Todos los Clientes --</option>
                                                {clientesList.map((cli) => (
                                                    <option key={cli.id} value={cli.id}>
                                                        {cli.nombre_cliente}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Estado Servicio */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">Estado Servicio</label>
                                            <select
                                                name="estado"
                                                value={filtros.estado}
                                                onChange={this.handleInputChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">-- Todos los Estados --</option>
                                                {estadosList.map((est) => (
                                                    <option key={est.id} value={est.id}>
                                                        {est.estado}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Estado Facturaci?n */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">Estado Facturaci?n</label>
                                            <select
                                                name="facturado"
                                                value={filtros.facturado}
                                                onChange={this.handleInputChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">-- Todos (Facturados / Sin Facturar) --</option>
                                                <option value="1">Facturados</option>
                                                <option value="0">Sin Facturar</option>
                                            </select>
                                        </div>

                                        {/* No. Expediente */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">N?mero Expediente</label>
                                            <input
                                                type="text"
                                                name="numero_expediente"
                                                placeholder="Buscar por expediente..."
                                                value={filtros.numero_expediente}
                                                onChange={this.handleInputChange}
                                                className="form-control form-control-sm"
                                            />
                                        </div>

                                        {/* Orden Servicio New */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">Orden Servicio (New)</label>
                                            <input
                                                type="text"
                                                name="orden_servicio_new"
                                                placeholder="Buscar por orden servicio..."
                                                value={filtros.orden_servicio_new}
                                                onChange={this.handleInputChange}
                                                className="form-control form-control-sm"
                                            />
                                        </div>

                                        {/* Numero Validador */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">N?mero Validador</label>
                                            <input
                                                type="text"
                                                name="numero_validador"
                                                placeholder="Buscar por validador..."
                                                value={filtros.numero_validador}
                                                onChange={this.handleInputChange}
                                                className="form-control form-control-sm"
                                            />
                                        </div>

                                        {/* Tarifa */}
                                        <div className="col-md-3">
                                            <label className="form-label small fw-bold">Tarifa</label>
                                            <input
                                                type="text"
                                                name="tarifa"
                                                placeholder="Buscar por tarifa..."
                                                value={filtros.tarifa}
                                                onChange={this.handleInputChange}
                                                className="form-control form-control-sm"
                                            />
                                        </div>

                                        {/* Filtro Tarifas = 0 */}
                                        <div className="col-md-4 d-flex align-items-center pt-2">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    id="tarifa_cero"
                                                    name="tarifa_cero"
                                                    checked={filtros.tarifa_cero}
                                                    onChange={this.handleInputChange}
                                                    className="form-check-input"
                                                />
                                                <label htmlFor="tarifa_cero" className="form-check-label small fw-bold text-danger">
                                                    Filtrar Servicios sin Tarifa (ID Tarifa = 0)
                                                </label>
                                            </div>
                                        </div>

                                        {/* Botones de acci?n */}
                                        <div className="col-md-8 d-flex align-items-center justify-content-end gap-2 pt-2">
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm px-4"
                                                onClick={this.cargarListadoServicios}
                                                disabled={cargando}
                                            >
                                                <FontAwesomeIcon icon={faSearch} className="me-1" />
                                                Filtrar
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm px-3"
                                                onClick={this.exportarExcel}
                                                disabled={cargando || servicios.length === 0}
                                            >
                                                <FontAwesomeIcon icon={faFileExcel} className="me-1" />
                                                Exportar a CSV
                                            </button>
                                            
                                            <input 
                                                type="file" 
                                                accept=".xlsx, .xls, .csv" 
                                                style={{display: 'none'}} 
                                                ref={this.fileInputRef} 
                                                onChange={this.handleExcelUpload} 
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm px-3 ms-2"
                                                onClick={() => this.fileInputRef.current && this.fileInputRef.current.click()}
                                                disabled={cargando || servicios.length === 0}
                                            >
                                                <FontAwesomeIcon icon={faUpload} className="me-1" />
                                                Subir Excel
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm px-3"
                                                onClick={this.limpiarFiltros}
                                                disabled={cargando}
                                            >
                                                <FontAwesomeIcon icon={faUndo} className="me-1" />
                                                Limpiar Filtros
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Barra de Selecci?n M?ltiple y Asignaci?n de Tarifa */}
                            {selectedIds.length > 0 && (
                                <div className="alert alert-info py-2 d-flex align-items-center justify-content-between mb-3 shadow-sm">
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon icon={faCheckSquare} className="text-info fs-5 me-2" />
                                        <span>
                                            <strong>{selectedIds.length}</strong> servicio(s) seleccionado(s)
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm fw-bold px-3"
                                        onClick={this.abrirModalTarifas}
                                    >
                                        <FontAwesomeIcon icon={faDollarSign} className="me-1" />
                                        Asignar / Actualizar Tarifa Seleccionados
                                    </button>
                                </div>
                            )}

                            {/* Panel de acciones para prefactura y conductores */}
                            <div className="d-flex justify-content-between align-items-center mb-2 mt-3">
                                <div>
                                    <button 
                                        className="btn btn-warning btn-sm me-2 fw-bold" 
                                        onClick={this.GuardarValores}
                                        disabled={this.state.idsFactura.length === 0}
                                    >
                                        <FontAwesomeIcon icon={faDollarSign} className="me-1" />
                                        Generar PreFactura ({this.state.idsFactura.length})
                                    </button>
                                    <button 
                                        className="btn btn-info btn-sm fw-bold text-white" 
                                        onClick={this.abrirModalConductores}
                                        disabled={this.state.idsConductor.length === 0}
                                    >
                                        Asignar Conductor Masivo ({this.state.idsConductor.length})
                                    </button>
                                    <button 
                                        className="btn btn-primary btn-sm ms-2 fw-bold text-white" 
                                        onClick={this.asignarProduccionMasiva}
                                        disabled={this.state.idsProduccion.length === 0}
                                    >
                                        Asignar Producción Masiva ({this.state.idsProduccion.length})
                                    </button>
                                </div>
                                <div className="fw-bold text-success fs-6 border border-success p-1 rounded bg-light">
                                    Subtotal Factura: ${this.state.subtotalFactura.toLocaleString('es-CO')}
                                </div>
                            </div>

                            {/* Scroll horizontal superior */}
                            <div 
                                ref={this.topScrollRef} 
                                style={{ overflowX: 'auto', marginBottom: '5px' }}
                                onScroll={() => {
                                    if (this.tableContainerRef.current && this.topScrollRef.current) {
                                        this.tableContainerRef.current.scrollLeft = this.topScrollRef.current.scrollLeft;
                                    }
                                }}
                            >
                                <div style={{ width: this.state.tableScrollWidth, height: '1px' }}></div>
                            </div>

                            {/* Tabla de Resultados */}
                            {cargando ? (
                                <div className="text-center py-5">
                                    <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-primary me-2" />
                                    <p className="mt-2 text-muted">Cargando listado de servicios...</p>
                                </div>
                            ) : (
                                <>
                                    <div 
                                        className="table-responsive"
                                        ref={this.tableContainerRef}
                                        style={{ maxHeight: '600px', overflowY: 'auto' }}
                                        onScroll={() => {
                                            if (this.topScrollRef.current && this.tableContainerRef.current) {
                                                this.topScrollRef.current.scrollLeft = this.tableContainerRef.current.scrollLeft;
                                            }
                                        }}
                                    >
                                        <table className="table table-hover table-bordered table-striped align-middle text-nowrap table-sm">
                                            <thead className="table-primary text-center" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                <tr>
                                                    <th style={{ width: '40px' }}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={isAllSelectedCurrentPage}
                                                            onChange={this.toggleSelectAllCurrentPage}
                                                            title="Seleccionar todos los de esta p?gina"
                                                        />
                                                    </th>
                                                    <th>ID</th>
                                                    <th className="align-middle" style={{ width: '70px' }}>
                                                        <label className="mb-0 d-flex flex-column align-items-center" style={{cursor: 'pointer'}}>
                                                            <input
                                                                type="checkbox"
                                                                onChange={this.toggleSelectAllFacturaCurrentPage}
                                                            />
                                                            <small style={{fontSize: '0.7em'}}>Facturar</small>
                                                        </label>
                                                    </th>
                                                    <th className="align-middle" style={{ width: '70px', fontSize: '0.8em' }}>Asignar Cond.</th>
                                                    <th>Fecha</th>
                                                    <th>Cliente / Origen</th>
                                                    <th className="align-middle text-center" style={{ width: '120px' }}>
                                                        <label className="mb-0 d-flex flex-column align-items-center" style={{cursor: 'pointer'}}>
                                                            <input
                                                                type="checkbox"
                                                                onChange={this.toggleSelectAllProduccionCurrentPage}
                                                            />
                                                            <small style={{fontSize: '0.8em'}}>Producción</small>
                                                        </label>
                                                    </th>
                                                    <th>Veh?culo Sugerido</th>
                                                    <th>Conductor</th>
                                                    <th>Estado</th>
                                                    <th>Factura</th>
                                                    <th>No. Expediente</th>
                                                    <th>Posici?n</th>
                                                    <th>Nombre Tarifa</th>
                                                    <th>Valor Tarifa</th>
                                                    <th>Valor Api</th>
                                                    <th>Valor Servicio</th>
                                                   {/*  <th>Diferencia</th> */}
                                                    <th>Pago a Conductor</th>
                                                    <th>Modalidad</th>
                                                    <th>Cantidad</th>
                                                    <th>Servicio Asociado</th>
                                                    <th>Orden Servicio (New)</th>
                                                    <th>No. Validador</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {serviciosPaginados.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="21" className="text-center py-4 text-muted">
                                                            No se encontraron registros con los filtros seleccionados.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    serviciosPaginados.map((item) => {
                                                        const isSelected = selectedIds.includes(item.id);
                                                        const valTarifa = Number(item.valor_tarifa || item.valor_sin_iva || 0);
                                                        const valServicio = Number(item.valor_servicio || 0);
                                                        const dif = valServicio - valTarifa;
                                                        const numFactura = item.factura_prefactura;
                                                        const valApi = item.valor_api || item.valor_api || '';
                                                        const permiteAsignarConductor = (!item.conductor && !item.nombre_conductor) || String(item.conductor) === '1055' || String(item.id_conductor) === '1055';

                                                        return (
                                                            <tr key={item.id} className={isSelected ? 'table-warning' : ''}>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={isSelected}
                                                                        onChange={() => this.toggleSelectRow(item.id)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <strong>#{item.id}</strong>{' '}
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-info btn-xs py-0 px-1 fw-bold ms-1"
                                                                        onClick={() => this.consultarBitacora(item.id)}
                                                                        title="Ver bit?cora / historial de cambios"
                                                                        style={{ fontSize: '11px', lineHeight: '1.2' }}
                                                                    >
                                                                        [C]
                                                                    </button>
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={this.state.idsFactura.includes(item.id)}
                                                                        onChange={() => this.handleCheckboxFacturaChange(item.id)}
                                                                        disabled={valServicio <= 0 || (numFactura && numFactura !== '0')}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    {permiteAsignarConductor ? (
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            checked={this.state.idsConductor.includes(item.id)}
                                                                            onChange={() => this.handleCheckboxConductorChange(item.id)}
                                                                        />
                                                                    ) : '-'}
                                                                </td>
                                                                <td>{item.fecha || '-'}</td>
                                                                <td>{item.nombre_cliente || '-'}</td>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input me-1"
                                                                            checked={this.state.idsProduccion.includes(item.id)}
                                                                            onChange={() => this.handleCheckboxProduccionChange(item.id)}
                                                                        />
                                                                        <input
                                                                            type="text"
                                                                            id={'produccion' + item.id}
                                                                            defaultValue={item.produccion || item.nombre_produccion || ''}
                                                                            onBlur={() => this.UpProduccion(item.id)}
                                                                            className="form-control form-control-sm fw-bold text-primary"
                                                                            style={{ width: '120px' }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>{item.vehiculo_sugerido || '-'}</td>
                                                                <td>{item.nombre_conductor || item.conductor || '-'}</td>
                                                                <td className="text-center">
                                                                    <span className="badge bg-info text-dark">
                                                                        {item.estado || 'SIN ESTADO'}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    {numFactura && numFactura !== '0' ? (
                                                                        <span className="badge bg-success fw-bold">
                                                                            {numFactura}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="badge bg-secondary">
                                                                            Sin Factura
                                                                        </span>
                                                                    )}
                                                                </td>
                                                                <td>{item.numero_expediente || '-'}</td>
                                                                <td>{item.posicion || '-'}</td>
                                                                <td>{item.nombre_tarifa || (item.tarifa ? `#${item.tarifa}` : '-')}</td>

                                                                <td>
                                                                    <strong>
                                                                        ${valTarifa.toLocaleString('es-CO')}
                                                                    </strong>
                                                                </td>
                                                                <td>
                                                                    <strong>
                                                                        ${valApi.toLocaleString('es-CO')}
                                                                    </strong>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        id={'valor' + item.id}
                                                                        defaultValue={item.valor_servicio}
                                                                        onBlur={() => this.UpValores(item.id)}
                                                                        className="form-control form-control-sm text-end fw-bold"
                                                                        style={{ width: '100px' }}
                                                                    />
                                                                </td>
                                                             {/*    <td className={dif !== 0 ? (dif > 0 ? 'text-success fw-bold' : 'text-danger fw-bold') : ''}>
                                                                    <strong>
                                                                        ${dif.toLocaleString('es-CO')}
                                                                    </strong>
                                                                </td> */}
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        id={'costo_tercero' + item.id}
                                                                        defaultValue={item.costo_tercero}
                                                                        onBlur={() => this.UpCostoTercero(item.id)}
                                                                        className="form-control form-control-sm text-end fw-bold text-success"
                                                                        style={{ width: '100px' }}
                                                                    />
                                                                </td>
                                                                <td>{item.modalidad || '-'}</td>
                                                                <td className="text-center">{item.cantidad || 0}</td>
                                                                <td className="text-center">
                                                                    {item.servicioAsociado && item.servicioAsociado !== '0' && item.servicioAsociado !== 0 ? (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-primary btn-xs py-0 px-2 fw-bold"
                                                                            onClick={() => this.consultarServicioCaracol(item.servicioAsociado, item.fecha)}
                                                                            title="Consultar servicio en Caracol TV"
                                                                        >
                                                                            <FontAwesomeIcon icon={faEye} className="me-1" />
                                                                            {item.servicioAsociado}
                                                                        </button>
                                                                    ) : (
                                                                        item.servicioAsociado || '-'
                                                                    )}
                                                                </td>
                                                                <td>{item.orden_servicio_new || '-'}</td>
                                                                <td>{item.numero_validador || '-'}</td>
                                                            </tr>
                                                        );
                                                    })
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Paginaci?n */}
                                    {true && (
                                        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                            <div className="d-flex align-items-center mb-2 mb-md-0">
                                                <label className="me-2 mb-0 small fw-bold">Registros por p?gina:</label>
                                                <select
                                                    className="form-select form-select-sm w-auto"
                                                    value={registrosPorPagina}
                                                    onChange={(e) => this.setState({ registrosPorPagina: parseInt(e.target.value), paginaActual: 1 })}
                                                >
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                    <option value="200">200</option>
                                                    <option value="500">500</option>
                                                    <option value="1000">1000</option>
                                                </select>
                                            </div>
                                            <span className="small text-muted mb-2 mb-md-0">
                                                Mostrando p?gina {paginaActual} de {totalPaginas} ({totalRegistros} registros en total)
                                            </span>
                                            <ul className="pagination pagination-sm mb-0">
                                                <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => this.cambiarPagina(paginaActual - 1)}
                                                    >
                                                        Anterior
                                                    </button>
                                                </li>
                                                {[...Array(totalPaginas).keys()].map((n) => {
                                                    const p = n + 1;
                                                    if (
                                                        p === 1 ||
                                                        p === totalPaginas ||
                                                        (p >= paginaActual - 2 && p <= paginaActual + 2)
                                                    ) {
                                                        return (
                                                            <li key={p} className={`page-item ${paginaActual === p ? 'active' : ''}`}>
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => this.cambiarPagina(p)}
                                                                >
                                                                    {p}
                                                                </button>
                                                            </li>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                                <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => this.cambiarPagina(paginaActual + 1)}
                                                    >
                                                        Siguiente
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* MODAL DE SELECCI?N DE TARIFA */}
                {showTarifaModal && (
                    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: '95vw' }}>
                            <div className="modal-content shadow-lg border-0">
                                <div className="modal-header bg-success text-white">
                                    <h5 className="modal-title">
                                        <FontAwesomeIcon icon={faDollarSign} className="me-2" />
                                        Seleccionar Tarifa para Asignar ({selectedIds.length} servicio(s))
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={this.cerrarModalTarifas}></button>
                                </div>
                                <div className="modal-body">
                                    {cargandoTarifas ? (
                                        <div className="text-center py-4">
                                            <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-success me-2" />
                                            <p className="mt-2 text-muted">Cargando tarifas del cliente...</p>
                                        </div>
                                    ) : tarifasCliente.length === 0 ? (
                                        <div className="alert alert-warning text-center my-3">
                                            No se encontraron tarifas registradas para el cliente seleccionado.
                                        </div>
                                    ) : (
                                        <>
                                            {/* Buscador de tarifas en modal */}
                                            <div className="mb-3">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text bg-light">
                                                        <FontAwesomeIcon icon={faSearch} />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Buscar por veh?culo, producci?n, modalidad o valor..."
                                                        value={filtroModalTarifa}
                                                        onChange={(e) => this.setState({ filtroModalTarifa: e.target.value })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                                <table className="table table-hover table-bordered table-striped align-middle text-nowrap table-sm">
                                                    <thead className="table-success text-center">
                                                        <tr>
                                                            <th className="text-center">Acci?n</th>
                                                            <th>Veh?culo</th>
                                                            <th>Producci?n</th>
                                                            <th>Modalidad</th>
                                                            <th>Disponibilidad</th>
                                                            <th>Valor Sin IVA</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tarifasFiltradas.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="5" className="text-center py-4 text-muted">
                                                                    No coinciden tarifas con el criterio de b?squeda.
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            tarifasFiltradas.map((t) => (
                                                                <tr key={t.id}>
                                                                    <td className="text-center">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success btn-xs px-3 fw-bold"
                                                                            onClick={() => this.seleccionarYActualizarTarifa(t)}
                                                                        >
                                                                            Seleccionar
                                                                        </button>
                                                                    </td>
                                                                    <td>{t.vehiculo || '-'}</td>
                                                                    <td>{t.produccion || '-'}</td>
                                                                    <td>{t.modalidad || '-'}</td>
                                                                    <td>{t.disponibilidad || '-'}</td>
                                                                    <td>
                                                                        <strong>
                                                                            ${Number(t.valor_sin_iva || 0).toLocaleString('es-CO')}
                                                                        </strong>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={this.cerrarModalTarifas}>
                                        <FontAwesomeIcon icon={faTimes} className="me-1" />
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* MODAL DE SERVICIOS DESDE CARACOL TV */}
                {showCaracolModal && (
                    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060 }}>
                        <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: '90vw' }}>
                            <div className="modal-content shadow-lg border-0">
                                <div className="modal-header bg-info text-white">
                                    <h5 className="modal-title">
                                        <FontAwesomeIcon icon={faEye} className="me-2" />
                                        Servicio desde Caracol TV (#{servicioAsociadoConsultado})
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={this.cerrarCaracolModal}></button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                    {cargandoCaracol ? (
                                        <div className="text-center py-5">
                                            <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-info me-2" />
                                            <p className="mt-2 text-muted">Consultando API de Caracol TV...</p>
                                        </div>
                                    ) : datosCaracol.length === 0 ? (
                                        <div className="alert alert-warning text-center my-3">
                                            No se encontraron datos en Caracol TV para el Servicio Asociado #{servicioAsociadoConsultado}.
                                        </div>
                                    ) : (
                                        datosCaracol.map((d, index) => (
                                            <div key={index} className="card border-0 shadow-sm mb-3">
                                                <div className="card-header bg-light d-flex justify-content-between align-items-center">
                                                    <span className="fw-bold text-primary">
                                                        ID Servicio Caracol: #{d.IdServicio}
                                                    </span>
                                                    <span className="badge bg-warning text-dark fs-6">
                                                        {d.estado || 'Sin registrar'}
                                                    </span>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row g-3">
                                                        <div className="col-md-4">
                                                            <strong className="text-secondary small d-block">Solicitante</strong>
                                                            <span>{d.NombresSolicitante || '-'} (ID: {d.IdSolicitante || '-'})</span>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <strong className="text-secondary small d-block">No. Solicitud</strong>
                                                            <span className="fw-bold">{d.NumeroSolicitud || '-'}</span>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <strong className="text-secondary small d-block">No. Pedido / Posici?n</strong>
                                                            <span>{d.NumeroPedido || '-'} (Posici?n: {d.Posicion || '-'})</span>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <strong className="text-secondary small d-block">Fecha Servicio / Hora Citaci?n</strong>
                                                            <span>
                                                                {d.FechaServicio ? new Date(d.FechaServicio).toLocaleDateString('es-CO') : '-'}
                                                                {d.HoraCitacion ? ` - ${d.HoraCitacion}` : ''}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <strong className="text-secondary small d-block">Tipo Veh?culo</strong>
                                                            <span>{d.TipoVehiculo || '-'}</span>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <strong className="text-secondary small d-block">Modalidad</strong>
                                                            <span>{d.Modalidad || '-'}</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <strong className="text-secondary small d-block">Material</strong>
                                                            <span>{d.Material || '-'} (ID: {d.IdMaterial || '-'})</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <strong className="text-secondary small d-block">Personas a Transportar</strong>
                                                            <span className="fw-bold text-success">{d.PersonasTransportar || '-'}</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <strong className="text-secondary small d-block">Destino / Direcci?n</strong>
                                                            <span>{d.Destino || '-'} - {d.Direccion || '-'}</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <strong className="text-secondary small d-block">Contacto</strong>
                                                            <span>{d.Contacto || '-'} {d.Telefono ? `(${d.Telefono})` : ''} {d.Email ? `- ${d.Email}` : ''}</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <strong className="text-secondary small d-block">Producto Ref / OI</strong>
                                                            <span>{d.ProductoRef || '-'} / {d.OI || '-'}</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <strong className="text-secondary small d-block">Descripci?n</strong>
                                                            <span>{d.Descripcion || '-'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={this.cerrarCaracolModal}>
                                        <FontAwesomeIcon icon={faTimes} className="me-1" />
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* MODAL DE BIT?CORA / HISTORIAL DE CAMBIOS */}
                {showBitacoraModal && (
                    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxWidth: '85vw' }}>
                            <div className="modal-content shadow-lg border-0">
                                <div className="modal-header bg-primary text-white">
                                    <h5 className="modal-title">
                                        <FontAwesomeIcon icon={faList} className="me-2" />
                                        Historial de Cambios / Bit?cora (Servicio #{servicioIdBitacora})
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={this.cerrarBitacoraModal}></button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                    {cargandoBitacora ? (
                                        <div className="text-center py-5">
                                            <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-primary me-2" />
                                            <p className="mt-2 text-muted">Cargando bit?cora del servicio...</p>
                                        </div>
                                    ) : datosBitacora.length === 0 ? (
                                        <div className="alert alert-info text-center my-3">
                                            No hay registros de seguimiento / cambios almacenados para el Servicio #{servicioIdBitacora}.
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-hover table-bordered table-striped align-middle text-nowrap table-sm">
                                                <thead className="table-primary text-center">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Fecha / Hora</th>
                                                        <th>Tipo Seguimiento</th>
                                                        <th>Acci?n</th>
                                                        <th>Usuario</th>
                                                        <th>IP</th>
                                                        <th>Detalle / Observaci?n</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datosBitacora.map((b) => (
                                                        <tr key={b.id}>
                                                            <td className="text-center"><strong>#{b.id}</strong></td>
                                                            <td>{b.fecha || '-'}</td>
                                                            <td className="text-center">
                                                                <span className="badge bg-secondary">
                                                                    {b.tipo_seguimiento_nombre || 'General'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span className="badge bg-dark">{b.accion || '-'}</span>
                                                            </td>
                                                            <td>{b.usuario || '-'}</td>
                                                            <td>{b.ip || '-'}</td>
                                                            <td className="text-wrap" style={{ maxWidth: '350px' }}>
                                                                {b.detalle || '-'}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={this.cerrarBitacoraModal}>
                                        <FontAwesomeIcon icon={faTimes} className="me-1" />
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* MODAL DE CONDUCTORES */}
                {this.state.showConductoresModal && (
                    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content shadow-lg border-0">
                                <div className="modal-header bg-info text-white">
                                    <h5 className="modal-title">
                                        Asignar Conductor ({this.state.idsConductor.length} servicio(s))
                                    </h5>
                                    <button type="button" className="btn-close btn-close-white" onClick={this.cerrarModalConductores}></button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                    {this.state.cargandoConductores ? (
                                        <div className="text-center py-4">
                                            <div className="spinner-border text-info" role="status"></div>
                                            <p className="mt-2 text-muted">Cargando conductores...</p>
                                        </div>
                                    ) : (
                                        <table className="table table-hover table-bordered table-striped align-middle text-nowrap table-sm">
                                            <thead className="table-info text-center">
                                                <tr>
                                                    <th>Acci?n</th>
                                                    <th>ID</th>
                                                    <th>Nombre</th>
                                                    <th>Apellido</th>
                                                    <th>Identificaci?n</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.conductoresList.map((c) => (
                                                    <tr key={c.id}>
                                                        <td className="text-center">
                                                            <input 
                                                                type="radio" 
                                                                name="conductor_radio"
                                                                checked={this.state.conductorSeleccionado === c.identificacion}
                                                                onChange={() => this.setState({ conductorSeleccionado: c.identificacion })}
                                                            />
                                                        </td>
                                                        <td className="text-center">{c.id}</td>
                                                        <td>{c.nombre}</td>
                                                        <td>{c.apellido}</td>
                                                        <td>{c.identificacion}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.cerrarModalConductores}>Cancelar</button>
                                    <button type="button" className="btn btn-info text-white" onClick={this.guardarConductorMasivo} disabled={!this.state.conductorSeleccionado}>
                                        Guardar Asignaci?n
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Mantenimiento;








